/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import './Badge.css';

class Badge extends Component {

  render() {
    let p = this.props.profile;

    let count = p.numEscapesComputed;
    let rate = p.escapeRateComputed;

    return (
      <Link to={'/p/' + p.username} className="Badge_wrapper">
      <div className="Badge">
        <div className="username">{p.username}</div>
        <div className="stat count">{count} room{count == 1 ? '' : 's'}</div>
        <div className="stat rate">{rate}% escaped</div>
      </div>
      </Link>
    );
  }
}

export default Badge;



/** WEBPACK FOOTER **
 ** ./src/components/partials/Badge.js
 **/